import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-review-status",
  "use": "foquz-icon-review-status-usage",
  "viewBox": "0 0 22 18",
  "content": "<symbol viewBox=\"0 0 22 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-review-status\"><path d=\"M4 1H1v16h3m14 0h3V1h-3M9 9h4M8.5 6H8a3 3 0 000 6h.5m5-6h.5a3 3 0 010 6h-.5\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol